<template lang="pug">
form-field-row(:style="{'--columns': __columns}" :data-row="id")
  slot
</template>

<script>
customElements.define(
  'form-field-row',
  class extends HTMLElement {
    constructor() {
      super();
    }
  }
);

export default {
  name: 'Field-Row',
  props: ['columns'],
  data() {
    return {
      style: document.createElement('style')
    }
  },
  computed: {
    id() {
      return Date.now() * Math.random() + Math.random();
    },
    __columns() {
      let columns;
      if (this.columns) {
        columns = this.columns.reduce((total, c) => (total += c, total), 0);
      }
      return columns;
    },
    __colSpans() {
      let colSpans;
      if (this.columns) {
        this.columns.reduce((css, span, i) => {
          let style = `[data-row="${this.id}"] *:nth-child(${i + 1}) {
            grid-column: span ${span};
          } `;
          css += style;
          return css;
        }, '');
      }
      return colSpans;
    }
  },
  watch: {
    __colSpans() {
      this.style.textContent = this.__colSpans;
    }
  },
  mounted() {
    if (this.__colSpans) {
      this.style.textContent = this.__colSpans;
      this.$el.insertAdjacentElement('beforeBegin', this.style);
    }
  },
  beforeUnmount() {
    if (this.__colSpans) {
      this.style.remove();
    }
  },
};
</script>

<style lang="scss" scoped>
form-field-row {
  @include field-row;
}
</style>
